import React from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer, Tooltip } from "recharts";

const MOCK_DATA = [
  { month: "Sep 25", value: 1820 },
  { month: "Oct 25", value: 1850 },
  { month: "Nov 25", value: 1870 },
  { month: "Dic 25", value: 1880 },
  { month: "Ene 26", value: 1910 },
  { month: "Feb 26", value: 1950 },
];

interface Props {
  currencySymbol?: string;
}

const ZoneTrends: React.FC<Props> = ({ currencySymbol = "$" }) => (
  <div className="mb-2 md:mb-6">
    <p className="text-base font-semibold text-gray-900 mb-3">Tendencias últimos 6 meses</p>
    <div className="bg-gray-100 rounded-xl p-4">
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={MOCK_DATA} margin={{ top: 5, right: 20, left: -15, bottom: 0 }}>
          <CartesianGrid strokeDasharray="1 1" horizontal={false} stroke="#e5e7eb" />
          <XAxis dataKey="month" tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={{ stroke: "#d1d5db" }} tickLine={false} interval={0} />
          <YAxis domain={[1600, 2000]} tick={{ fontSize: 11, fill: "#9ca3af" }} axisLine={{ stroke: "#d1d5db" }} tickLine={false} tickFormatter={(v) => v.toLocaleString("en-US")} />
          <Tooltip formatter={(v: number) => [`${currencySymbol}${v.toLocaleString("en-US")}`, "Precio m²"]} contentStyle={{ borderRadius: 8, fontSize: 13 }} />
          <Line type="monotone" dataKey="value" stroke="#212529" strokeWidth={2} dot={{ r: 4, fill: "#212529" }} activeDot={{ r: 6 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
    <p className="text-xs text-gray-500 my-1">
      Datos estimados con base en publicaciones y transacciones verificadas.
    </p>
  </div>
);

export default ZoneTrends;
